<template>
  <NichesContent />
</template>

<script>
import { mapGetters } from 'vuex';
import NichesContent from '@/components/Niches/NichesContent';

export default {
  nuxtI18n: {
    paths: {
      en: '/niches/:slug',
      de: '/nischen/:slug',
      es: '/nichos/:slug',
      pt: '/nichos/:slug'
    }
  },
  components: {
    NichesContent
  },
  async validate({ params, store }) {
    const currentPage = params.page ? parseInt(params.page) : 1;

    store.dispatch('niches/CLEAN_NICHES');
    await Promise.all([
      store.dispatch('niches/LOAD_NICHE', { slug: params.slug }),
      store.dispatch('niches/LOAD_NICHE_CONTENT', {
        slug: params.slug,
        page: currentPage
      })
    ]);
    return store.state.niches.nicheContent.length;
  },
  async fetch({ store }) {
    const { en, de, es, pt } = store.state.niches.niche.metadata;
    const slugs = {
      en: { slug: en },
      de: { slug: de },
      es: { slug: es },
      pt: { slug: pt }
    };
    store.dispatch('i18n/setRouteParams', slugs);
  },
  head() {
    const metadata = this.$store.state.niches.niche.metadata;
    const i18nSeo = this.$seoPlugin({ slash: true, canonicalLink: metadata?.cannonical });
    const openGraph = this.$openGraphPlugin(
      metadata?.metaTitle,
      'website',
      this.$route.path,
      metadata?.metaDescription,
      this.getImageFirstResult,
      this.$store.state.i18n.locale
    );
    return {
      title: metadata?.metaTitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: metadata?.metaDescription
        },
        ...openGraph
      ],
      link: [...i18nSeo.link]
    };
  },
  computed: {
    ...mapGetters('niches', ['getImageFirstResult'])
  }
};
</script>
